import { useState } from "react";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { Typography } from "@mui/material";
import "./dataUpload.css";

const VideoPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoId = "7N_0jmA37N4"; // Extracted from the video URL
  const videoUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "205px",
        borderRadius: "14px",
        background: "#F5F5F5",
      }}
    >
      {isPlaying ? (
        <iframe
          width="100%"
          height="100%"
          src={videoUrl}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
          title="Video Player"
          style={{ borderRadius: "14px" }}
        ></iframe>
      ) : (
        <div
          style={{
            backgroundImage: `url(https://img.youtube.com/vi/${videoId}/maxresdefault.jpg)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "100%",
            borderRadius: "14px",
            position: "relative",
          }}
        >
          <div className="video-overlay" onClick={() => setIsPlaying(true)}>
            <PlayArrowIcon className="play-icon" />
            <Typography variant="body1" className="watch-video-text">
              Watch Video
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoPlayer;
